import { defineComponent as _defineComponent } from 'vue'
interface Props {
  text?: string | string[] | null;
  left?: boolean;
  top?: boolean;
  right?: boolean;
  bottom?: boolean;
  maxWidth?: number | string;
  nudgeLeft?: number;
  nudgeRight?: number;
  nudgeTop?: number;
  nudgeBottom?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    text: null,
    left: { type: Boolean },
    top: { type: Boolean },
    right: { type: Boolean },
    bottom: { type: Boolean },
    maxWidth: null,
    nudgeLeft: null,
    nudgeRight: null,
    nudgeTop: null,
    nudgeBottom: null
  },
  setup(__props: any) {





return { __sfc: true, }
}

})